import { render } from "./polygon-contact.vue?vue&type=template&id=636dbe5f&scoped=true&ts=true"
import script from "./polygon-contact.vue?vue&type=script&lang=ts"
export * from "./polygon-contact.vue?vue&type=script&lang=ts"

import "./polygon-contact.vue?vue&type=style&index=0&id=636dbe5f&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636dbe5f"]])

export default __exports__